module.exports = __webpack_public_path__ + "img/ava-small.86ab18358c1ad42bf2b3c72fadcb1831.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ava-small.png
// module id = 68
// module chunks = 1